import { render, staticRenderFns } from "./AddNewUser.vue?vue&type=template&id=6d707eb4&scoped=true&"
import script from "./AddNewUser.vue?vue&type=script&lang=js&"
export * from "./AddNewUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d707eb4",
  null
  
)

export default component.exports